import { inRushStageAtom } from '@/components/features/casino/rush/state';
import { useAtomValue } from 'jotai';
import GrandPrizeProgress from './GrandPrizeProgress';

export default function RushProgress() {
  const inRushStage = useAtomValue(inRushStageAtom);
  return <>{inRushStage && <GrandPrizeProgress />}</>;
}
